import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b40f832"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "d-flex justify-content-end align-items-center",
  id: "MenusOverviewItemReferenceEdit"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "edit", -1))
const _hoisted_3 = ["data-bs-title"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "error", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["data-bs-title"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "warning", -1))
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.pageId)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: {name: 'edit-content-page-wysiwyg', params: {id: _ctx.pageId}},
          class: "btn btn-sm btn-light btn-icon"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["to"]))
      : _createCommentVNode("", true),
    (_ctx.isDeleted)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: "d-flex align-items-center text-danger ms-2",
          "data-bs-toggle": "tooltip",
          "data-bs-title": _ctx.$t('linkedPageDeleted')
        }, _hoisted_5, 8, _hoisted_3))
      : (_ctx.isNotPublished)
        ? (_openBlock(), _createElementBlock("span", {
            key: 2,
            class: "d-flex align-items-center text-warning ms-2",
            "data-bs-toggle": "tooltip",
            "data-bs-title": _ctx.$t('linkedPageNotPublished'),
            "data-bs-placement": "top"
          }, _hoisted_8, 8, _hoisted_6))
        : _createCommentVNode("", true)
  ]))
}